import produce from "immer";
import { get, toInteger } from "lodash";
import { parse } from "query-string";
import create from "zustand";

export enum PaginationKey {
  workspaceHotspots = "workspace-hotspots",
  workspaceLocations = "workspace-locations",
  workspaceWallets = "workspace-wallets",
  workspaceContacts = "workspace-contacts",
  workspaceInstalls = "workspace-installs",
  settingsLabels = "settings-labels",
  settingsCommissionTemplates = "settings-commission-templates",
  workspacePaymentTransactions = "workspace-payment-transactions",
  workspaceCommissionReports = "workspace-commission-reports",
  workspaceCommissionReportContacts = "workspace-commission-report-contacts",
  contactPaymentTransactions = "contact-payment-transactions",
  contactPayments = "contact-payments",
  hexHotspots = "hex-hotspots",
  hexLocations = "hex-locations",
  hotspotWitnesses = "hotspot-witnesses",
  locationWitnessesVisibleHotspots = "location-witnesses-visible-hotspots",
  locationWitnessesVisibleLocations = "location-witnesses-visible-locations",
  locationSuperSimulations = "location-super-simulations"
}

type PaginationState = {
  resultsPerPage: { [paginationKey: string]: number };
  changeResultsPerPage: (paginationKey: string, newValue: number) => void;
  getPaginationInfo: (
    paginationKey: PaginationKey,
    itemsCount: number,
    locationSearch: string
  ) => {
    page: number;
    pages: number;
    startIndex: number;
    endIndex: number;
    resultsPerPage: number;
  };
};

const usePagination = create<PaginationState>((set, getState) => ({
  resultsPerPage: {
    [PaginationKey.workspacePaymentTransactions]: 5,
    [PaginationKey.contactPaymentTransactions]: 5
  },
  changeResultsPerPage: (paginationKey, newValue) =>
    set((state) =>
      produce(state, (draft) => {
        draft.resultsPerPage[paginationKey] = newValue;
      })
    ),
  getPaginationInfo: (paginationKey, itemsCount, locationSearch) => {
    const resultsPerPage =
      getState().resultsPerPage[paginationKey] || DEFAULT_RESULTS_PER_PAGE;
    const queryParams = parse(locationSearch);
    const page = toInteger(get(queryParams, `${paginationKey}-page`, "1"));
    const startIndex = (page - 1) * resultsPerPage;
    const endIndex = Math.min(page * resultsPerPage, itemsCount);
    const pages = Math.ceil(itemsCount / resultsPerPage);
    return { page, pages, startIndex, endIndex, resultsPerPage };
  }
}));

export default usePagination;

//
// Utils
//

const DEFAULT_RESULTS_PER_PAGE = 25;
